// extracted by mini-css-extract-plugin
export default {"root":"LayoutWrapperFooter_root__m263e"};